import $ from "jquery";
import "slick-carousel";
import { PageName } from "./constants";
import { getSiblings, loadData } from "./utils";
import modalNavigation from "./modal-navigation";
import modalForm from "./modal-form";
import modalPanorama from "./modal-panorama";
import toggleLocales from "./toggle-locales";
import modal3dTour from "./modal-3d";
import modalTrezini from "./modal-trezini";

const names = {
  [`razumovskiy`]: `razum`,
  [`volkonskiy`]: `volk`,
  [`kushelev`]: `kush`,
  [`main`]: `main`,
  [`loft`]: `loft`,
  [`whitebox`]: `whitebox`,
};

const classNames = {
  DESCRIPTION_ACTIVE: `flats-types__description--active`,
  TEXT_VISIBLE: `flats-types__text--visible`,
  CONTROL_ACTIVE: `flats-types__toggle--active`,
  FLAT_INFO_LINK_HIDDEN: `flats-types__link--hidden`,
  BOTTOM_LINKS_WRAP_EXPANDED: `flats-types__links--expanded`,
  PROMO_HIDDEN: `flats-types__promo--hidden`,
};

const FlatInfoSource = {
  [`razumovskiy`]: `/flats/razumovskiy`,
  [`volkonskiy`]: `/flats/volkonskiy`,
  [`kushelev`]: `/flats/kushelev`,
};
const windowWidth = window.innerWidth; //TODO: optimize window width usage

export default class FlatsTypesPage {
  constructor() {
    this.page = document.querySelector(`.page`);
    this.slider = this.page.querySelector(`#types-slider`);
    this.controls = [...this.page.querySelectorAll(`.js-slider-toggle`)];
    this.descriptions = [
      ...this.page.querySelectorAll(`.flats-types__description`),
    ];
    this.slides = [...this.page.querySelectorAll(`.flats-types__slide`)];
    this.bottomLinksWrap = this.page.querySelector(`.flats-types__links`);
    this.flatInfoLink = this.page.querySelector(`.js-flat-info`);
    this.promo = this.page.querySelector(`.flats-types__promo`);
    this.presentation = this.page.querySelector(`.js-modal-form`);
    this.tour3DLinks = this.page.querySelectorAll(`.js-tour-3d`);
    this.tour3DToggle = this.page.querySelectorAll(`.js-modal-3d`);
    this.panoramaLink = this.page.querySelector(`.js-modal-panorama`);
    this.panorama = "";
    this.hashAnchor = window.location.hash;
  }

  init(locale) {
    this.locale = locale;
    this.formatValues();
    this.initModals();
    this.initSlider();
    toggleLocales();
    this.bindHandlers();
  }

  formatValues() {
    const formatPhone = () => {
      const phones = this.page.querySelectorAll(`.js-phone`);
      const pattern = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})?[- ]?(\d{2})/g;
      const subst = " ($1) $2 $3 $4";

      phones.forEach((phone) => {
        phone.innerHTML = phone.innerHTML.replace(pattern, subst);
      });
    };

    formatPhone();
  }

  initSlider() {
    let slideNum = 0;
    if (this.hashAnchor == "#razumovskiy") {
      slideNum = 1;
    } else if (this.hashAnchor == "#volkonskiy") {
      slideNum = 7;
    } else if (this.hashAnchor == "#kushelev") {
      slideNum = 12;
    } else {
      slideNum = 0;
    }

    $(this.slider).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      cssEase: "ease-out",
      initialSlide: slideNum,
    });

    const active = this.slider.querySelector(
      `.slick-active.slick-current .flats-types__slide`
    );
    const activeType = active.dataset.type;
    const activeSlideNumber = active.dataset[names[activeType]];

    this.toggleDescriptions(activeType, names[activeType], activeSlideNumber);

    if (this.controls.length) {
      this.toggleControlsState(active.dataset.slide || active.dataset.type);
    }

    if (this.flatInfoLink) {
      this.toggleFlatInfoLink(active.dataset.slide);
    }

    if (this.tour3DLinks) {
      this.toggleTour3DLink(active.dataset.slide);
    }

    if (this.panoramaLink) {
      if (active.dataset.slide) {
        let panoramaImgUrl = active.getAttribute("data-panorama-img-url");
        if (panoramaImgUrl !== "") {
          this.panoramaLink.setAttribute("data-panorama-img", panoramaImgUrl);
          this.panoramaLink.classList.remove("link--hidden");
        } else {
          if (!this.panoramaLink.classList.contains("link--hidden")) {
            this.panoramaLink.classList.add("link--hidden");
          }
        }
      }
    }

    if (this.promo) {
      this.togglePromoVisibility(active);
    }

    $(this.slider).on("afterChange", () => {
      const active = this.slider.querySelector(
        `.slick-active.slick-current .flats-types__slide`
      );
      const activeType = active.dataset.type;
      const activeSlideNumber = active.dataset[names[activeType]];

      this.toggleDescriptions(activeType, names[activeType], activeSlideNumber);

      if (this.controls.length) {
        this.toggleControlsState(active.dataset.slide || active.dataset.type);
      }

      if (this.flatInfoLink) {
        this.toggleFlatInfoLink(active.dataset.slide);
      }

      if (this.tour3DLinks) {
        this.toggleTour3DLink(active.dataset.slide);
      }

      if (this.panoramaLink) {
        if (active.dataset.slide) {
          let panoramaImgUrl = active.getAttribute("data-panorama-img-url");
          if (panoramaImgUrl !== "") {
            this.panoramaLink.setAttribute("data-panorama-img", panoramaImgUrl);
            this.panoramaLink.classList.remove("link--hidden");
          } else {
            if (!this.panoramaLink.classList.contains("link--hidden")) {
              this.panoramaLink.classList.add("link--hidden");
            }
          }
        }
      }

      if (this.promo) {
        this.togglePromoVisibility(active);
      }
    });
  }

  toggleDescriptions = (name, type, number) => {
    if (!name) return;

    const activeDescription = this.descriptions.find(
      (item) => item.dataset.slide === name
    );
    const texts = [...activeDescription.querySelectorAll(`.text`)];
    const activeText = texts.find((text) => text.dataset.text === number);
    const descriptionSiblings = getSiblings(activeDescription);
    const textSiblings = getSiblings(activeText);

    descriptionSiblings.forEach((item) =>
      item.classList.remove(classNames.DESCRIPTION_ACTIVE)
    );
    activeDescription.classList.add(classNames.DESCRIPTION_ACTIVE);

    textSiblings.forEach((item) =>
      item.classList.remove(classNames.TEXT_VISIBLE)
    );
    activeText.classList.add(classNames.TEXT_VISIBLE);
  };

  toggleControlsState = (name) => {
    if (!name) return;

    if (name === `main`) {
      this.controls.forEach((control) => {
        control.classList.remove(classNames.CONTROL_ACTIVE);
      });
      return;
    }

    const activeControl = this.controls.find(
      (item) => item.dataset.link === name
    );
    const siblings = getSiblings(activeControl);

    if (name && name !== `main`) {
      window.location.hash = activeControl.getAttribute("href");
    }

    siblings.forEach((item) =>
      item.classList.remove(classNames.CONTROL_ACTIVE)
    );
    activeControl.classList.add(classNames.CONTROL_ACTIVE);
  };

  togglePromoVisibility(slide) {
    const shouldBeShown = slide.dataset.promo;

    this.promo.classList.toggle(classNames.PROMO_HIDDEN, !shouldBeShown);
  }

  toggleFlatInfoLink = (name) => {
    //TODO: optimize condition
    if (560 < windowWidth) {
      if (name !== `main`) {
        this.bottomLinksWrap.classList.add(
          classNames.BOTTOM_LINKS_WRAP_EXPANDED
        );
        setTimeout(() => {
          this.flatInfoLink.classList.remove(classNames.FLAT_INFO_LINK_HIDDEN);
        }, 500);
      } else {
        this.flatInfoLink.classList.add(classNames.FLAT_INFO_LINK_HIDDEN);
        setTimeout(() => {
          this.bottomLinksWrap.classList.remove(
            classNames.BOTTOM_LINKS_WRAP_EXPANDED
          );
        }, 200);
      }
    } else {
      this.flatInfoLink.classList.remove(classNames.FLAT_INFO_LINK_HIDDEN);
    }

    if (name) {
      this.flatInfoLink.setAttribute(
        `href`,
        `/${this.locale}${FlatInfoSource[name]}`
      );
      document
        .querySelector(".wrapper")
        .setAttribute("data-panorama", `${name}`);
      if (
        name === "razumovskiy" ||
        name === "volkonskiy" ||
        name === "kushelev"
      ) {
        document.querySelector("button.js-modal-panorama").style.display =
          "block";
      }
    }
  };

  toggleTour3DLink = (name) => {
    if (name) {
      this.tour3DLinks.forEach(function (link) {
        if (
          link.classList.contains(`js-tour-3d--${name}`) &&
          link.innerHTML !== "" &&
          link.querySelector(".link").getAttribute("href") !== ""
        ) {
          link.classList.remove("link--hidden");
        } else {
          link.classList.add("link--hidden");
        }
      });
    }
  };

  goToSelectedSlide = (e) => {
    const selectedSlide = this.slides.find(
      (slide) => slide.dataset.slide === e.currentTarget.dataset.link
    );

    if (selectedSlide) {
      $(this.slider).slick("slickGoTo", selectedSlide.dataset.index);
    }
  };

  initModals = () => {
    modalNavigation.init(this.isMobile, PageName.FLATS, this.locale);
    if (this.presentation) {
      modalForm.init();
    }
    if (document.querySelector(".wrapper").getAttribute("data-panorama")) {
      modalPanorama.init({
        container: () => document.querySelector("div.panorama"),
        wrapperClass: ".flats-types__3d",
        itemClass: ".js-modal-panorama",
        onShow: (event, _pano) => {
          return event.currentTarget.dataset.panoramaImg;
        },
      });
    }
    if (this.tour3DToggle.length) {
      modal3dTour.init(this.tour3DToggle);
    }
    modalTrezini.init();
  };

  bindHandlers() {
    this.controls.forEach((control) => {
      control.addEventListener(`click`, this.goToSelectedSlide);
    });

    if (this.presentation) {
      this.presentation.addEventListener(`click`, (e) => {
        e.preventDefault();
      });
    }
  }
}
